export const prevent = (event) => (event.preventDefault(), event);
